// extracted by mini-css-extract-plugin
export default {"titleMobile":"UlOeM2","mobileFontSize":"bPAkhj","dateLocationMobile":"mUCh9I"};